import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ReactMarkdown from 'react-markdown';
import OnVisible from 'react-on-visible';
import breaks from 'remark-breaks';
import { containers, Grid } from 'style';
import { Spacer200 } from '..';

const MarkdownHeading = props => {
    return (
        <div className={`h${props.level}`}>
            {props.children}
        </div>
    );
};

const FooterComponent = ({ heroText, firstAddress, secondAddress, additionText }) => (
    <OnVisible percent={20}>
        <Grid.Wrapper backgroundColor={'#000'} textColor={'#fff'}>
            <div className="wrapper">
            <Spacer200 />
            <div id="FooterComponent" className="markdown container-fluid">
                <div className="row">
                    <Col className='col-xs-12 links-visible tomoslab'>
                        <ReactMarkdown
                            source={heroText}
                            plugins={[breaks]}
                            renderers={{
                                root: 'div',
                                heading: MarkdownHeading,
                            }}
                        />
                    </Col>
                </div>
                <Spacer200 />
                <div className="row">
                    <div className="col-xs-12">
                        <RowWrapper>
                            <FooterContactFirstAddress>
                                <ReactMarkdown
                                    source={firstAddress}
                                    plugins={[breaks]}
                                    renderers={{ root: 'div', paragraph: 'div' }}
                                />
                            </FooterContactFirstAddress>
                            <FooterContactSecondAddress>
                                <ReactMarkdown
                                    source={secondAddress}
                                    plugins={[breaks]}
                                    renderers={{ root: 'div', paragraph: 'div' }}
                                />
                            </FooterContactSecondAddress>
                            <FooterContactLinks>
                                <ReactMarkdown
                                    source={additionText}
                                    plugins={[breaks]}
                                    renderers={{ root: 'div', paragraph: 'div' }}
                                />
                            </FooterContactLinks>
                        </RowWrapper>
                    </div>
                </div>
            </div>
            <Spacer200 />
            </div>
        </Grid.Wrapper>
    </OnVisible>
);
const Col = styled.div`

    @media (max-width: ${containers.medium}px) {
      .h1{
        display: inline;
        margin-right: .5rem;
      }
    }

    &.tomoslab {
        font-family: 'TomoSlab';
        font-weight: 100;
    }
`;
const RowWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    @media (min-width: ${containers.innerPX}px) {
      flex-wrap: nowrap;
    }
`;

const FooterContactInfo = css`
    /* white-space: nowrap; */
    a {
        color: inherit;
    }
    transition: all 0s;
    transform: translateY(40px);
    opacity: 0.01;

    margin-bottom: ${containers.padding}px;

    .visible & {
        transition: all 0.5s;
        transform: translateY(0px);
        opacity: 1;
    }
    @media (min-width: ${containers.innerPX}px) {
        padding: 0;
        width: 30%;
    }

    div + div{
      margin-top: 26px;
    }
`;

const FooterContactFirstAddress = styled.div`
    ${FooterContactInfo};
    /* order: 0; */
`;
const FooterContactSecondAddress = styled.div`
    ${FooterContactInfo};
    /* order: 3; */
    /* margin-top: ${containers.padding}px; */
    @media (min-width: 750px) {
        /* order: 1; */
        /* margin-top: 0; */
    }
`;
const FooterContactLinks = styled.div`
    ${FooterContactInfo};
    /* order: 4; */
    /* margin-top: ${containers.padding}px; */
    @media (min-width: 375px) {
        /* order: 1; */
        /* margin-top: 0; */
    }
`;

export default FooterComponent;
